import { cn } from '@hub-la/shadcn'
import React from 'react'
import { IFile } from '../../../domain/dtos'
import { Envs } from '../../../envs'
import { useUploadImage } from '../../hooks/use-upload-image'

type Props = {
  name: string
  path: string
  onChange: (file?: IFile) => void
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  onLoad?: (n: number) => void
  children?: React.ReactNode
  accept?: string
  obfuscateFileName?: boolean
  className?: string
}

export const Uploader: React.FC<Props> = ({
  name,
  path,
  onChange,
  setLoading,
  onLoad,
  accept,
  children,
  className = '',
  obfuscateFileName = false,
}) => {
  const { mutateAsync } = useUploadImage()

  const handleUpload = (file: File) => {
    setLoading(true)
    mutateAsync({ input: file, path, onLoad, obfuscateFileName }).then((file) => {
      setLoading(false)
      onChange(file)
    })
  }

  return (
    <label htmlFor={name} className={cn('cursor-pointer', className)}>
      <input
        type="file"
        id={name}
        name={name}
        data-testid={name}
        className="hidden m-0 p-0"
        accept={accept ?? Envs.ATTACHMENT_IMAGE_MIMETYPE_ALLOWED}
        onChange={(e) => {
          if (e.target.files && e.target.files[0]) {
            handleUpload(e.target.files[0])
            e.target.value = ''
          }
        }}
      />
      {children}
    </label>
  )
}
